import React, { useEffect } from 'react'
import classNames from 'classnames'
import { makeStyles, Typography, Box } from 'transfix-ui/core'
import Grid from 'transfix-ui/core/Grid'
import Skeleton from 'transfix-ui/core/Skeleton'
import { brandColors } from 'transfix-ui/theme/colors'
import { useJobHistory } from 'apps/spot-quote-control-panel/hooks/useJobHistory'
import { datetimeFormatter } from 'transfix-ui'

interface ISidePanelHistorySection {
  jobId: string
  updateLoading: boolean
}

const useStyles = makeStyles(theme => ({
  columns: {
    marginBottom: theme.spacing(1.5),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  columnHeaders: {
    color: brandColors.coolGray5,
  },
  sectionHeader: {
    marginBottom: theme.spacing(1),
  },
}))

export const SidePanelHistorySection = ({ jobId, updateLoading }: ISidePanelHistorySection) => {
  const classes = useStyles()
  const { jobHistory, jobHistoryLoading, refetchJobHistory } = useJobHistory({ jobId })
  const headerClass = classNames(classes.columnHeaders, classes.columns)

  const formattedTime = (time: string) =>
    datetimeFormatter({
      datetime: time,
      displayTimezone: 'America/New_York',
      format: 'dateAndYearFullDateAlways',
    })

  useEffect(() => {
    if (!updateLoading) {
      refetchJobHistory()
    }
  }, [updateLoading, refetchJobHistory])

  return (
    <div>
      <Typography className={classes.sectionHeader} variant='subtitle1'>
        History
      </Typography>
      <Grid container spacing={2} className={headerClass}>
        <Grid xs={5} item>
          Update
        </Grid>
        <Grid xs={7} item>
          Update
        </Grid>
      </Grid>
      {jobHistoryLoading && (
        <Box px={2}>
          <Skeleton width='100%' height={40} />
          <Skeleton width='100%' height={40} />
          <Skeleton width='100%' height={40} />
        </Box>
      )}
      {jobHistory.map(job => {
        return (
          <Grid
            container
            spacing={2}
            className={classes.columns}
            key={`job-history-${job.updatedAt}`}>
            <Grid xs={5} item>
              {formattedTime(job.updatedAt)}
            </Grid>
            <Grid xs={7} item>
              {job.desc}
            </Grid>
          </Grid>
        )
      })}
    </div>
  )
}
